import {styled} from '@mui/material';
import OSGroupAccordion from './OSGroupAccordion';

// Extensão do OSGroupAccordion com hover e borda personalizada
export default styled(OSGroupAccordion)(({theme}) => ({
    'marginBottom': theme.spacing(2),
    'transition': 'box-shadow 0.2s',
    '&:hover .MuiAccordion-root': {
        boxShadow: theme.shadows[4],
    },
    '& .MuiAccordion-root': {
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
    },
    '& .MuiAccordionSummary-root': {
        backgroundColor: theme.palette.primary.light,
    },
    '& .MuiAccordionDetails-root': {
        backgroundColor: theme.palette.background.default,
    },
}));
